import RefreshIcon from 'src/assets/icons/RefreshIcon';
import Button from 'src/components/design-system/Button';
import ClearFilterButton from 'src/components/design-system/ClearFilterButton';

interface IProps {
  clearFilter: () => void;
  clearSelection: () => void;
  handleRefresh: () => void;
  isLoading: boolean;
  isClearFiltersDisabled: boolean;
}
const CreateReceiptToolBar: React.FC<IProps> = ({
  clearFilter,
  handleRefresh,
  clearSelection,
  isLoading,
  isClearFiltersDisabled,
}) => (
  <div className="flex  w-full">
    <ClearFilterButton onClick={clearFilter} disabled={isClearFiltersDisabled} />
    <Button color="info" className="hover:bg-secondary-hover" onClick={clearSelection}>
      Clear Selection
    </Button>
    <div className="flex-1" />
    <Button
      color="info"
      onClick={handleRefresh}
      startIcon={<RefreshIcon width="16px" color="white" />}
      loading={isLoading}
    >
      Refresh List
    </Button>
  </div>
);

export default CreateReceiptToolBar;
